module.exports = __webpack_public_path__ + "static/img/3205.b5c8bfbd.jpg";